export default "__VITE_ASSET__CRmxXBqi__"